// import api from './api';
import { apiUtils } from '../utils/api';

export const getPaymentsList = async () => {
  return await apiUtils.get('payments/');
};

export const createPayment = async (form) => {
  const payload = {
    invoice: form.invoice,
    total_amount: form.total_amount,
    payment_method: form.payment_method,
    payment_datetime: form.payment_datetime,
    paid_amount: form.paid_amount
  };
  const response = await apiUtils.post('payments/', payload);
  return response.data;
}; 